/* JS needed for branding page templates */

import './effects.js'
import responsiveNav from './responsive-nav.jquery.js'


(($) => {

    $.fn.responsiveNav = responsiveNav

    $('html').removeClass('no-js').addClass('js');

    $('nav.br-main-nav').responsiveNav({
        menuButtonSelector: '.br-site-header__menu-btn'
    });

})(jQuery);